import { jsx as _jsx } from "react/jsx-runtime";
import CheckIcon from "@mui/icons-material/Check";
import { Button } from "@mui/material";
export const SingleSelectControl = ({ selected, selectedText, unselectedText, disabled, onClick, }) => {
    return (_jsx(Button, Object.assign({ variant: "text", color: selected ? "success" : "inherit", onClick: () => {
            !disabled && onClick();
        }, disabled: disabled, startIcon: selected && _jsx(CheckIcon, { color: "success" }) }, { children: selected ? selectedText : unselectedText })));
};
